<div class="container">
  <div class="row top mt-5 mx-0">
    <div class="col-md-6 text align-self-center px-0 px-lg-4 p-xl-6 text-center text-md-start">
      <h1 class="fw-bold">
        <ng-content select="[heading-top]"></ng-content>
      </h1>
      <p>
        <ng-content select="[text-top]"></ng-content>
      </p>
      <div class="mt-4" *ngIf="bg">
        <ng-content select="[button-top]"></ng-content>
      </div>
    </div>
    <div class="col-md-6 img mt-4 mt-md-0 align-self-center">
      <ng-content select="[img-top]"></ng-content>
    </div>
  </div>
</div>
<ng-container *ngIf="bg; else insurance">
  <div class="container container-bottom">
    <div class="row bottom mt-5 scale-container">
      <div class="col-md-6 img align-self-center order-md-1 order-2 mt-md-0 mt-5">
        <div class="p-3 p-md-5 text-center scale-obj" [ngStyle]="{'background-color': bg}">
          <ng-content select="[img-bot]"></ng-content>
        </div>
      </div>
      <div class="col-md-6 text align-self-center mt-4 mt-md-0">
        <h2 class="mb-2 mb-md-3">
          <ng-content select="[title]"></ng-content>
        </h2>
        <p>
          <ng-content select="[text-bot]"></ng-content>
        </p>
        <div class="mt-4">
          <ng-content select="[button-bot]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="fundraising">
  <div class="container container-bottom">
    <div class="row bottom mt-5 scale-container">
      <div class="col-md-6 text align-self-center mt-4 mt-md-0">
        <h2 class="mb-2 mb-md-3">
          <ng-content select="[fundraising-title]"></ng-content>
        </h2>
        <p>
          <ng-content select="[fundraising-text-bot]"></ng-content>
        </p>
        <div class="mt-4 mb-md-0 mb-3">
          <ng-content select="[fundraising-button-bot]"></ng-content>
        </div>
      </div>
      <div class="col-md-6 img align-self-center">
        <div class="p-3 p-md-5 text-center scale-obj" [ngStyle]="{'background-color': bg}">
          <ng-content select="[fundraising-img-bot]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #insurance>
  <ng-content select="[insurance]"></ng-content>
</ng-template>
<div class="container">
  <frequently-questions *ngIf="!fundraising && faq.length>0" [data]="faq"></frequently-questions>
</div>
<stories-carousel></stories-carousel>